import type { Section } from '../types/onboarding'

interface SectionProgressProps {
  currentSection: Section
}

const sectionLabels: Record<Section, string> = {
  profile: 'Profile',
  lifestyle: 'Lifestyle',
  motivation: 'Your Plan',
  plan: 'Get Started',
}

const sections: Section[] = ['profile', 'lifestyle', 'motivation', 'plan']

export function SectionProgress({ currentSection }: SectionProgressProps) {
  const currentIndex = sections.indexOf(currentSection)

  return (
    <div className="flex items-center gap-2">
      {sections.map((section, index) => {
        const isCompleted = index < currentIndex
        const isCurrent = index === currentIndex

        return (
          <div key={section} className="flex items-center flex-1">
            <div className="flex flex-col items-center flex-1">
              <div
                className={`
                  h-1.5 w-full rounded-full transition-all duration-300
                  ${isCompleted ? 'bg-primary' : isCurrent ? 'bg-primary' : 'bg-gray-200'}
                `}
              />
              <span
                className={`
                  text-xs mt-1.5 font-medium transition-colors duration-300
                  ${isCompleted || isCurrent ? 'text-primary' : 'text-gray-400'}
                `}
              >
                {sectionLabels[section]}
              </span>
            </div>
            {index < sections.length - 1 && (
              <div className="w-1" />
            )}
          </div>
        )
      })}
    </div>
  )
}
